import { createContext } from "react";
import { useEnsureContext } from "@madmedical/utils";
const PatientMeasurementsContext = createContext(undefined);
export const PatientMeasurementsProvider = PatientMeasurementsContext.Provider;
export const usePatientMeasurements = () => useEnsureContext(PatientMeasurementsContext);
